<template>
<!--  临床应用-->
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="itemData.imgBoxUrl" class="el-image__inner">
      </div>
    </div>
<!--    &lt;!&ndash;    导航&ndash;&gt;-->
<!--    <div class="num_all">-->
<!--      <el-row >-->
<!--        <el-col :span="18" :justify="end" ><div class="grid-content num_r">-->
<!--          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">-->
<!--            <el-menu-item  v-for="item in itemData.numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>-->
<!--          </el-menu>-->
<!--        </div></el-col>-->
<!--      </el-row>-->
<!--    </div>-->

<!--    <div class="contentBox" v-show="showData.box1">-->
<!--      <div class="cu_all">-->
<!--        <div class="cli_d_1">{{ itemData.item.text1 }}</div>-->
<!--        <div class="cli_img">-->
<!--          <el-image-->
<!--            style="width: 1176px; height: 700px"-->
<!--            :src="itemData.item.imageUrl"-->
<!--            :fit="contain" v-show="showData.img1"></el-image>-->
<!--          <video :src="itemData.videoUrl" v-show="showData.video1"></video>-->
<!--        </div>-->
<!--        <div class="cli_d_2" v-if="itemData.item.text2 != ''" >{{itemData.item.text2}}</div>-->
<!--      </div>-->

<!--    </div>-->
    <div class="contentBox" >
      <div class="cu_all">
        <div class="cli_d_1">{{ boxData.text1 }}</div>
        <div class="cli_img">
          <img
            class = "img_nn"
            :src="boxData.imageUrl" v-if="boxData.imageUrl"></img>


          <video v-if="boxData.videoUrl" class="video_nn" controls>
            <source :src="boxData.videoUrl" type="video/mp4">
          </video>
        </div>
        <div class="cli_d_2" v-if="boxData.text2" >{{boxData.text2}}</div>
      </div>

    </div>

  </div>
</template>

<script>
import Mun2 from "./image/mun2";
import {Data} from "./js/clinical";
export default {
  name: "clinical",
  components: {Mun2},
  data() {
    return {
      dataAll: Data,
      itemData: {},
      urlData:"",
      boxData:{},
      numIndex: "1",

    }
  },
  mounted() {
    let that = this;
    console.log("init");
    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }
    that.init();
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);

      if(that.urlData == "" || that.urlData == undefined){
        that.boxData = itemData.itemList[0]
      } else {
        for(let index in that.itemData.itemList){
          let itemData= that.itemData.itemList[index];
          if(that.urlData == itemData.path){
            that.boxData = itemData
            break;
          }
        }

      }

    },

  }
}
</script>

<style scoped>
.img_nn{
  width: 100%;
  aspect-ratio: 1176/700;
}
.video_nn{
  width: 100%;
  aspect-ratio: 1176/700;
}
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.cli_img{
  margin-top: 35px;
  margin-bottom: 25px;
}
.cli_d_2{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0.39px;
  text-align: justify;
  line-height: 32px;
  white-space: pre-wrap;
}
.cli_d_1{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
}
.cu_all{
  width: 100%;
}
.contentBox {
  width: 61.25%;
  margin: 50px auto;
  display: flex;
  justify-content: center;
}
.productPage {
  display: block;
  width: 100%;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  aspect-ratio: 1920/600;
}

.imageItem {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/clinical.vue